

import { Box, CircularProgress, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../components/CustomText";
import PricingCard from "../../../components/Cards/PricingCard";
import { useSelector } from "react-redux";
import pricingcard1 from "../../../assets/pricingcard1.svg";
import pricingcard2 from "../../../assets/pricingcard2.svg";
import pricingcard3 from "../../../assets/pricingcard3.svg";
import { decryptToken } from "../../../Utlis/Encryption";
import back from "../../../assets/back.svg"
import { BASE_URL } from "../../../components/BaseUrl";
import { formatNumber } from "../../../components/FormatNumber";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../components/CustomButton";
import { toast } from "react-hot-toast"
import { useNavigate } from "react-router-dom";
import { Upgrade } from "@mui/icons-material";
import logoutmodel from "../../../assets/logoutmodel.svg";
import warning from "../../../assets/warning.svg";
import {
  Modal,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const API_URL =
  // `${BASE_URL}/payments/plans?page=1&limit=105&sort_order=desc&is_active=true`
  `${BASE_URL}/payments/plans?page=1&limit=105&sort_order=desc&is_active=true`
  ;
const IMAGES = [pricingcard1, pricingcard2, pricingcard3];

const getLocaleKey = (language) => (language?.startsWith("es") ? "es" : "en");

const mapPlanForDisplay = (plan, idx, localeKey) => {
  const localized = plan[localeKey] || plan.en || {};
  const planId = plan.plan_id || String(idx);

  return {
    key: planId,
    image: IMAGES[idx % IMAGES.length],
    title: localized.name || plan.name || "Plan",
    amount: plan.amount,
    currency: plan.currency || "USD",
    description: localized.description || plan.description || "",
    features: Array.isArray(localized.features)
      ? localized.features
      : Array.isArray(plan.features)
        ? plan.features
        : [],
    billing_cycle_label: localized.billing_cycle_label || "",
    duration_type: plan.duration_type || "month",
    is_attendance:
      plan.is_attendance || String(planId).includes("attendance"),
  };
};
const UpgradePlans = ({ upgradeRequired, currentPlanId, subscriptionStatus, detailedStatus, currentWorkerCount }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t, i18n } = useTranslation();
  // console.log("currentPlanId",currentPlanId)
  const [rawPlans, setRawPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [billing, setBilling] = useState("monthly"); // toggle state
  const token = useSelector((state) => state.auth.token);
  const upgradeToken = new URLSearchParams(window.location.search).get("upgrade_token");
  const decryptedToken = upgradeToken || (token ? decryptToken(token) : null);
  const isUpgradeAccess = Boolean(upgradeToken);
  const [subscribingPlan, setSubscribingPlan] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const navigate = useNavigate()
  const [totalWorkers, setTotalWorkers] = useState(0);
  const [workersLoading, setWorkersLoading] = useState(true);

  const fetchWorkerCount = async () => {
    if (isUpgradeAccess) {
      setQuantity(Number(currentWorkerCount) || 1);
      setWorkersLoading(false);
      return;
    }
    try {
      setWorkersLoading(true);

      const url = `${BASE_URL}/company-admins/workers?no_pagination=true`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });

      const json = await res.json();
      console.log("WORKER API RESPONSE 👉", json);
      if (!json.error) {
        // const total = json?.data?.pagination?.total ?? 0;
        const total =
          json?.data?.pagination?.total ??
          json?.data?.workers?.length ??
          0;
        setTotalWorkers(total);
        setQuantity(total);   // 👈 initialize quantity from API only
      } else {
        toast.error(json.message || "Failed to load worker count");
      }
    } catch (err) {
      console.error("❌ Worker count fetch error:", err);
      toast.error("Something went wrong fetching worker count.");
    } finally {
      setWorkersLoading(false);
    }
  };



  const [showWorkerAfterCancelModal, setShowWorkerAfterCancelModal] = useState(false);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(API_URL, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) throw new Error(`Failed: ${res.status}`);

      const json = await res.json();
      console.log("📋 Plans API full response:", json);

      const raw = Array.isArray(json?.data?.plans) ? json.data.plans : [];
      console.log("📋 Raw fetched plans:", raw);
      console.log("📋 Raw plans count:", raw.length);

      const active = raw.filter((p) => p?.is_active === true);
      console.log("📋 Active plans:", active);
      console.log("📋 Active plans count:", active.length);

      setRawPlans(active);
    } catch (e) {
      setError(e.message || "Error loading plans");
    } finally {
      setLoading(false);
    }
  };

  // useEffect for initial load
  useEffect(() => {
    fetchPlans();
  }, []);

  const plans = useMemo(() => {
    const localeKey = getLocaleKey(i18n.language);
    const mapped = rawPlans.map((p, idx) => mapPlanForDisplay(p, idx, localeKey));
    console.log(`📋 Mapped plans (${localeKey}):`, mapped);
    return mapped;
  }, [rawPlans, i18n.language]);


  const visiblePlans = useMemo(() => {
    // Map billing state to duration_type value
    // "monthly" -> "month", "yearly" -> "year"
    const durationType = billing === "monthly" ? "month" : "year";

    console.log("🔍 Filtering plans:", { billing, durationType, totalPlans: plans.length });

    // First filter by duration_type (month/year) from API
    let filtered = plans.filter((p) => {
      console.log("📦 Plan:", { title: p.title, duration_type: p.duration_type, key: p.key });
      return p.duration_type === durationType;
    });

    console.log("📦 After duration filter:", filtered.length);

    // Always hide free plan
    filtered = filtered.filter((p) => p.key !== "free");

    console.log("📦 After free plan filter:", filtered.length);

    // Sort: attendance plan first, then by amount
    filtered.sort((a, b) => {
      // If one is attendance and other is not, attendance comes first
      if (a.is_attendance && !b.is_attendance) return -1;
      if (!a.is_attendance && b.is_attendance) return 1;

      // If both are attendance or both are not, sort by amount
      return (a.amount || 0) - (b.amount || 0);
    });

    console.log("📦 Final filtered plans:", filtered.length);
    return filtered;
  }, [plans, billing]);


  const handleSubscribe = async (planId, workerCount) => {
    try {
      setSubscribingPlan(planId);

      if (!decryptedToken) {
        toast.error(t("alerts.auth_missing"));
        return;
      }

      const upgradeQuery = upgradeToken
        ? `&upgrade_token=${encodeURIComponent(upgradeToken)}`
        : "";
      const url = `${BASE_URL}/payments/company-admin/generate-payment-link?plan_id=${planId}&worker_count=${workerCount}&payment_type=recurring${upgradeQuery}`;
      console.log("🔹 Fetching payment link...");
      console.log("➡️ URL:", url);
      console.log("➡️ Token:", decryptedToken ? "Token present ✅" : "No token ❌");
      console.log("➡️ Calling PayPal Link API with:", { planId, workerCount });
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      console.log("🔹 Response Status:", res.status);
      const json = await res.json();
      console.log("🔹 Response JSON of paypal :", json);

      if (!res.ok || json.error) {
        console.error("❌ API Error:", json.message);
        throw new Error(json.message || t("alerts.payment_link_failed"));
      }

      if (json?.data?.approval_url
      ) {
        console.log("✅ Redirecting to PayPal URL:", json.data.approval_url
        );
        window.location.href = json.data.approval_url
          ;
      } else {
        // toast.success( t("alerts.payment_link_success"));
      }
    } catch (e) {
      console.error("🔥 handleSubscribe error:", e);
      toast.error(e.message || t("alerts.general_error"));
    } finally {
      setSubscribingPlan(null);
    }
  };


  const [pricingResult, setPricingResult] = useState(null);
  const [calculating, setCalculating] = useState(false);

  const handleCalculate = useCallback(async (planId, qty, silent = false) => {
    try {
      if (!decryptedToken) {
        toast.error(t("alerts.auth_missing"));
        return;
      }
      setCalculating(true);
      if (!silent) setPricingResult(null);

      const res = await fetch(`${BASE_URL}/payments/calculate-price`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
        body: JSON.stringify({
          plan_id: planId,
          worker_count: String(qty),
        }),
      });

      const json = await res.json();
      if (!res.ok || json.error) throw new Error(json.message || t("alerts.calculate_error"));
      console.log("Calculating price for:", { planId, qty });
      if (!silent) toast.success(t("alerts.calculate_success"));
      setPricingResult(json.data);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    } finally {
      setCalculating(false);
    }
  }, [decryptedToken, t]);

  const workerModalOpen = openModal || showWorkerAfterCancelModal;

  useEffect(() => {
    if (!workerModalOpen || !selectedPlan || workersLoading || quantity <= 0) return;

    const timer = setTimeout(() => {
      handleCalculate(selectedPlan, quantity, true);
    }, 400);

    return () => clearTimeout(timer);
  }, [workerModalOpen, selectedPlan, quantity, workersLoading, handleCalculate]);

  const handleContinue = async () => {
    if (!pricingResult) {
      toast.error("Please calculate price first");
      return;
    }

    const planId = pricingResult.pricing.plan_id;
    const workerCount = pricingResult.pricing.worker_count;

    console.log("🧾 handleContinue → planId:", planId);
    console.log("🧾 handleContinue → workerCount:", workerCount);

    await handleSubscribe(planId, workerCount);
  };





  const handleSwitchPlan = async () => {
    try {
      if (!selectedPlan) {
        toast.error(t("alerts.no_plan_selected"));
        return;
      }

      setCanceling(true);

      const res = await fetch(`${BASE_URL}/payments/company-admin/switch-plan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
        body: JSON.stringify({
          new_plan_id: selectedPlan,
          worker_count: String(pricingResult?.pricing?.worker_count),

        }),
      });

      const json = await res.json();
      console.log("Switch plan API response:", json);

      if (!res.ok || json.error) throw new Error(json.message || t("alerts.switch_plan_error"));
      ;

      // SUCCESS MESSAGE
      toast.success(t("alerts.switch_plan_success"));

      // Close modal
      setShowCancelModal(false);

      const approvalUrl = json?.data?.new_subscription?.approval_url;

      // If approval URL exists → redirect
      if (approvalUrl) {
        setTimeout(() => {
          window.location.href = approvalUrl;
        }, 1200); // allow toast to show
      } else {
        // No redirect needed
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      }

    } catch (err) {
      toast.error(err.message);
    } finally {
      setCanceling(false);
    }
  };



  return (
    <>


      <Box sx={{ px: 4, py: 4,
                
       }}>


        <Box mt={0} mb={4} sx={{
          display: "flex", justifyContent: "center",

        }}>
          <Box
            display="flex"
            sx={{
              gap: "8px",
              minWidth: isMobile ? "80px" : "140px",
              border: "1px solid #006EC2",
              borderRadius: "50px",
            }}
          >
            <Box
              onClick={() => setBilling("monthly")}
              sx={{
                px: isMobile ? 2 : 4,
                cursor: "pointer",
                borderRadius: "48px",
                //   backgroundColor: billing === "monthly" ? "#868282" : "none",
                backgroundColor: billing === "monthly" ? "#006EC2" : "none",
                color: billing === "monthly" ? "#FFFFFF" : "#006EC2",
                transition: "background-color 0.2s, color 0.2s",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {t("pricing.monthly")}
            </Box>

            <Box
              onClick={() => setBilling("yearly")}
              sx={{
                px: isMobile ? 2 : 3,
                py: isMobile ? 0.5 : 1,
                cursor: "pointer",
                borderRadius: "50px",
                backgroundColor: billing === "yearly" ? "#006EC2" : "none",
                color: billing === "yearly" ? "#FFFFFF" : "#006EC2",
                transition: "background-color 0.2s, color 0.2s",
                textAlign: "center",
                minWidth: isMobile ? "80px" : "100px",
              }}
            >
              {t("pricing.yearly")}
            </Box>
          </Box>
        </Box>

        {/* Loader / Error */}
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {error && <Box sx={{ color: "red", textAlign: "center" }}>{error}</Box>}

        {/* Plans Grid */}
        <Box
          sx={{
  
            px: isMobile ? 0.5 : 0,
            display: "grid",
            gap: 3,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, minmax(0, 1fr))",
            },
          }}
        >
          {visiblePlans.map((plan) => {
            // console.log("Plan:", plan); // full object
            // console.log("Comparing:", plan.key, "with currentPlanId:", currentPlanId);

            return (
              <Box key={plan.key}>
                <PricingCard
                  imageSrc={plan.image}
                  title={plan.title}
                  price={formatNumber(plan.amount, true)}
                  priceLabel={`${plan.currency} / ${t("pricing.users")} / ${plan.billing_cycle_label || (plan.duration_type === "month" ? t("pricing.monthly") : t("pricing.yearly"))}`}
                  description={plan.description}
                  features={plan.features}


                  buttonText={
                    plan.key === "free"
                      ? t("Continue for free") // 👈 show this text for free plan
                      : subscriptionStatus === "trial"
                        ? t("Upgrade") // if trial, all buttons show "Upgrade"
                        : subscriptionStatus === "cancelled"
                          ? t("Buy") // if cancelled, show "Buy"
                          : String(plan.key) === String(currentPlanId)
                            ? t("Subscribed") // current active plan
                            : subscribingPlan === plan.key
                              ? (
                                <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
                                  <CircularProgress size={18} sx={{ color: "white" }} />
                                  {t("Upgrade")}
                                </Box>
                              )
                              : t("Upgrade")
                  }



                  onButtonClick={() => {
                    console.log("Button clicked for plan:", plan.key);
                    console.log("Current subscriptionStatus:", subscriptionStatus);
                    console.log("detailedStatus:", detailedStatus);
                    const hasActiveSubscription =
                      subscriptionStatus === "active" ||
                      subscriptionStatus === "active_paid" ||
                      detailedStatus === "active_subscription";

                    if (hasActiveSubscription) {
                      setSelectedPlan(plan.key);      // store selected plan
                      setQuantity(currentWorkerCount); // optional: pass actual count
                      setShowCancelModal(true);
                    } else {
                      setSelectedPlan(plan.key);
                      setPricingResult(null);
                      fetchWorkerCount();
                      setOpenModal(true);
                    }


                  }}

                  disabled={subscribingPlan === plan.key}
                />
              </Box>
            );
          })}


        </Box>
      </Box>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            width: 360,
            textAlign: "center",
          }}
        >
          {/* Close icon */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>

            <CustomText sx={{ ...textStyles.h6, mb: 2, mt: 1, color: "#333" }}>
              {t("subscriptionPage.choose_worker_count")}
            </CustomText>
            <IconButton
              onClick={() => setOpenModal(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "#666",
                "&:hover": { color: "#000" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>


          </Box>

          {workersLoading || quantity === null ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                mb: 2,
              }}
            >
              <IconButton
                onClick={() => {
                  setQuantity((p) => {
                    if (p <= totalWorkers) {
                      toast.error("You cannot reduce workers below your total workers.");
                      return p;
                    }
                    return p - 1;
                  });
                }}
                size="small"
                sx={{
                  backgroundColor: quantity <= totalWorkers ? "#e0e0e0" : "#f0f0f0",
                  border: "1px solid #ccc",
                  "&:hover": {
                    backgroundColor: quantity <= totalWorkers ? "#e0e0e0" : "#e0e0e0",
                  },
                }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>

              <Box
                sx={{
                  minWidth: 60,
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#333",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  py: 0.5,
                  px: 1,
                }}
              >
                {quantity}
              </Box>

              <IconButton
                onClick={() => setQuantity((p) => Math.min(1000, p + 1))}
                size="small"
                sx={{
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          )}


          {/* Pricing Summary Card */}
          {calculating && !pricingResult && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <CircularProgress size={24} />
            </Box>
          )}
          {pricingResult && (
            <Box
              sx={{
                backgroundColor: "#F9FAFB",
                borderRadius: 2,
                p: 2,
                mb: 2,
                textAlign: "left",
                border: "1px solid #ddd",
                opacity: calculating ? 0.6 : 1,
              }}
            >
              <CustomText
                // text={pricingResult.pricing.plan_name}
                text={pricingResult?.pricing?.plan_name || "Calculated Plan"}
                sx={{ ...textStyles.h6, color: "#333" }}
              />

              <Box
                sx={{
                  fontSize: "13px",
                  mt: 2,
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.billing_cycle")}</span>
                  <span>{pricingResult.billing_cycle}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.workers")}</span>
                  <span>{pricingResult.pricing.worker_count}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.base")}</span>
                  <span>{pricingResult.pricing.base_amount}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.additional_workers")}</span>
                  <span>{pricingResult.pricing.additional_workers}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.additional_cost")}</span>
                  <span>{pricingResult.pricing.additional_worker_cost}</span>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 1,
                    fontWeight: "bold",
                    borderTop: "1px solid #ddd",
                    pt: 1,
                  }}
                >
                  <span>{t("subscriptionPage.total")}</span>
                  <span>
                    {pricingResult.pricing.total_amount}{pricingResult.currency}
                  </span>
                </Box>
              </Box>
            </Box>
          )}

          {/* Action Button */}
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              disabled={!pricingResult || calculating || subscribingPlan === selectedPlan}
              sx={{
                backgroundColor: "#2E7D32",
                color: "#fff",
                textTransform: "none",
                "&:hover": { backgroundColor: "#256628" },
              }}
              onClick={handleContinue}
            >
              {subscribingPlan === selectedPlan ? (
                <CircularProgress size={22} sx={{ color: "#fff" }} />
              ) : calculating ? (
                <CircularProgress size={22} sx={{ color: "#fff" }} />
              ) : (
                t("subscriptionPage.continue")
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 3,
            borderRadius: 2,
            width: 400,
            textAlign: "center",
            boxShadow: 24,
          }}
        >

          <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
            <img
              src={warning}
              alt="logout"
              style={{ width: 50, height: 50 }}
            />
          </Box>

          <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, lineHeight: "13px", mb: 2, mt: 2, color: "#2C384C" }}>
            {t("activePlanTitle")}
          </CustomText>

          <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, lineHeight: "23px", mb: 2, color: "#2C384C" }}>
            {t("activePlanSubtitle")}
          </CustomText>

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              sx={{
                color: "#333", borderColor: "#aaa",
                fontFamily: 'Poppins, sans-serif',
                textTransform: "capitalize !important"
              }}
              onClick={() => {
                setShowCancelModal(false); // just close
              }}
            >
              No
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#d32f2f",
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
                textTransform: "capitalize !important"
              }}
              onClick={() => {
                setShowCancelModal(false);
                setPricingResult(null);
                fetchWorkerCount();
                setShowWorkerAfterCancelModal(true);
              }}
              disabled={canceling}
            >
              {canceling ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>


      <Modal
        open={showWorkerAfterCancelModal}
        onClose={() => setShowWorkerAfterCancelModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            width: 360,
            textAlign: "center",
          }}
        >
          {/* Close icon */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText sx={{ ...textStyles.h6, mb: 2, mt: 1, color: "#333" }}>
              {t("subscriptionPage.choose_worker_count")}
            </CustomText>

            <IconButton
              onClick={() => setShowWorkerAfterCancelModal(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "#666",
                "&:hover": { color: "#000" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Quantity Selector */}
          {/* Quantity Selector */}
          {workersLoading || quantity === null ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                mb: 2,
              }}
            >
              <IconButton
                onClick={() => {
                  setQuantity((p) => {
                    if (p <= totalWorkers) {
                      toast.error("You cannot reduce workers below your total workers.");
                      return p;
                    }
                    return p - 1;
                  });
                }}
                size="small"
                sx={{
                  backgroundColor: quantity <= totalWorkers ? "#e0e0e0" : "#f0f0f0",
                  border: "1px solid #ccc",
                  "&:hover": {
                    backgroundColor: quantity <= totalWorkers ? "#e0e0e0" : "#e0e0e0",
                  },
                }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>

              <Box
                sx={{
                  minWidth: 60,
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#333",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  py: 0.5,
                  px: 1,
                }}
              >
                {quantity}
              </Box>

              <IconButton
                onClick={() => setQuantity((p) => Math.min(1000, p + 1))}
                size="small"
                sx={{
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          )}

   
    
       


          {/* Pricing Summary */}
          {calculating && !pricingResult && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <CircularProgress size={24} />
            </Box>
          )}
          {pricingResult && (
            <Box
              sx={{
                backgroundColor: "#F9FAFB",
                borderRadius: 2,
                p: 2,
                mb: 2,
                textAlign: "left",
                border: "1px solid #ddd",
                opacity: calculating ? 0.6 : 1,
              }}
            >
              <CustomText
                text={pricingResult?.pricing?.plan_name || "Calculated Plan"}
                sx={{ ...textStyles.h6, color: "#333" }}
              />

              <Box
                sx={{
                  fontSize: "13px",
                  mt: 2,
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.billing_cycle")}</span>
                  <span>{pricingResult.billing_cycle}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.workers")}</span>
                  <span>{pricingResult.pricing.worker_count}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.base")}</span>
                  <span>{pricingResult.pricing.base_amount}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.additional_workers")}</span>
                  <span>{pricingResult.pricing.additional_workers}</span>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{t("subscriptionPage.additional_cost")}</span>
                  <span>{pricingResult.pricing.additional_worker_cost}</span>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 1,
                    fontWeight: "bold",
                    borderTop: "1px solid #ddd",
                    pt: 1,
                  }}
                >
                  <span>{t("subscriptionPage.total")}</span>
                  <span>
                    {pricingResult.pricing.total_amount}
                    {pricingResult.currency}
                  </span>
                </Box>
              </Box>
            </Box>
          )}

          {/* Action Button */}
          <Box sx={{ mt: 2 }}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              disabled={!pricingResult || calculating || canceling}
              sx={{
                textTransform: "none",
                "&:hover": { backgroundColor: "#256628" },
              }}
              onClick={handleSwitchPlan}
            >
              {canceling ? (
                <CircularProgress size={22} sx={{ color: "#fff" }} />
              ) : calculating ? (
                <CircularProgress size={22} sx={{ color: "#fff" }} />
              ) : (
                t("subscriptionPage.upgrade")
              )}
            </Button>
          </Box>
        </Box>
      </Modal>

    </>
  );
};

export default UpgradePlans;














